import MuiTooltip, { TooltipProps as MuiTooltipProps } from "@mui/material/Tooltip";
import React, { forwardRef, FunctionComponent, ReactNode } from "react";
import { useLocale } from "designSystem/locale";

export interface TooltipProps extends Omit<MuiTooltipProps, "title"> {
	/** localization resource to use to lookup text; can be simple resource or type resource (i.e. "User.Name") */
	res?: string;

	/** parameters to pass if looking up resource */
	resParams?: Array<number | string>;

	/** non-localized title for tooltip; the localized tooltip will take precendence */
	title?: ReactNode;
};

const Tooltip: FunctionComponent<TooltipProps> = forwardRef((props, ref) => {
	const { res, resParams, title, ...otherProps } = props;
	const text = res ? useLocale()
		.resource(res, resParams) : "";

	return (
		<MuiTooltip
			ref={ref}
			title={text || title}
			{...otherProps}
		/>
	);
});

export default Tooltip;
